import type { Optimization } from '../lib/types'
import { ActionCard } from './ActionCard'

export function OptimizationChecklist({
  optimizations,
  reportId,
}: {
  optimizations: Optimization[]
  reportId: string
}) {
  // "Registrada" é da AÇÃO: o status é único, vale para todos.
  const registered = optimizations.filter((o) => o.state.status !== 'pending').length

  return (
    <section className="rounded-xl border border-slate-200 bg-slate-50/60 p-5">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="text-lg font-bold text-slate-900">Ações de Otimização</h2>
        <span className="text-sm text-slate-500">
          {registered} de {optimizations.length} registradas
        </span>
      </div>
      <div className="space-y-3">
        {optimizations.map((o) => (
          <ActionCard key={o.id} action={o} kind="optimization" reportId={reportId} />
        ))}
        {optimizations.length === 0 && (
          <p className="text-sm text-slate-500">Nenhuma ação de otimização gerada.</p>
        )}
      </div>
    </section>
  )
}
